import request from "@/utils/request";

let AssembleApi = {
    /*拼团活动列表*/
    activeList(data, errorback) {
        return request._post("/merch/activity.assemble/index", data, errorback);
    },
    getGoods(data, errorback) {
        return request._get("/merch/activity.assemble/add", data, errorback);
    },
    addGoods(data, errorback) {
        return request._post("/merch/activity.assemble/add", data, errorback);
    },
    /*我的活动列表*/
    myList(data, errorback) {
        return request._post("/merch/activity.assemble/my", data, errorback);
    },
    /*根据主键查询*/
    detailGoods(data, errorback) {
        return request._get("/merch/activity.assemble/edit", data, errorback);
    },
    /*根据主键查询*/
    saveGoods(data, errorback) {
        return request._post("/merch/activity.assemble/edit", data, errorback);
    },
    delGoods(data, errorback) {
        return request._post("/merch/activity.assemble/del", data, errorback);
    }
};
export default AssembleApi;



// WEBPACK FOOTER //
// ./src/api/assemble.js